import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#4A5D4E]/30 border-t-[#4A5D4E] rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[#6B6A65]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={redirectState} replace />;
  }

  return children;
};

export default ProtectedRoute;
